export const formatApiErrorDetail = (detail, fallback = 'Si è verificato un errore. Riprova.') => {
  if (detail == null || detail === '') return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => {
      if (typeof item === 'string') return item;
      if (item?.msg) return item.msg;
      if (item?.message) return item.message;
      return '';
    }).filter(Boolean);
    return messages.length ? messages.join(' · ') : fallback;
  }
  if (typeof detail === 'object') {
    return String(detail.message || detail.msg || detail.detail || fallback);
  }
  return String(detail);
};